{
	"name": "snikgraph",
	"version": "25.01",
	"description": "SNIK Graph",
	"main": "js/browser/main.ts",
	"type": "module",
	"homepage": "https://github.com/snikproject/graph#readme",
	"dependencies": {
		"@types/cytoscape": "^3.21.9",
		"@types/jquery": "^3.5.32",
		"@types/micromodal": "^0.3.5",
		"@types/node": "^25.9.1",
		"@types/stats": "^0.16.30",
		"cytoscape": "3.33.4",
		"cytoscape-context-menus": "^4.2.1",
		"cytoscape-euler": "^1.2.4",
		"cytoscape-svg": "^0.4.0",
		"fuse.js": "^7.4.0",
		"golden-layout": "^1.5.9",
		"hotkeys-js": "^4.0.4",
		"jquery": "^3.7.1",
		"loglevel": "^1.9.2",
		"micromodal": "^0.6.2",
		"notyf": "^3.10.0",
		"spin.js": "^4.1.2",
		"stats.js": "^0.17.0",
		"tippy.js": "^6.3.7"
	},
	"devDependencies": {
		"husky": "^9.1.7",
		"lint-staged": "^17.0.7",
		"prettier": "^3.8.3",
		"typedoc": "^0.28.19",
		"typedoc-plugin-merge-modules": "^7.0.0",
		"typescript": "^6.0.3",
		"vite": "^8.0.16",
		"vite-plugin-oxlint": "2.1.1",
		"vitest": "^4.1.8"
	},
	"keywords": [
		"graph",
		"visualisation",
		"visualization",
		"ontology",
		"snik",
		"hospital information management",
		"cytoscape"
	],
	"bugs": {
		"url": "https://github.com/snikproject/graph/issues"
	},
	"scripts": {
		"dev": "vite",
		"build": "vite build --sourcemap true",
		"preview": "vite preview",
		"test": "vitest run --pool=forks",
		"lint": "oxlint",
		"fix": "oxlint --fix",
		"typecheck": "tsc --noEmit",
		"fmt": "prettier --write js --cache",
		"doc": "typedoc --plugin typedoc-plugin-merge-modules",
		"manual": "vite-node node/generateManual.mjs && prettier --write html/manual.html",
		"prepare": "husky"
	},
	"lint-staged": {
		"*.{js,mjs,ts}": [
			"prettier --write --cache"
		],
		"*.{html,css,json}": [
			"prettier --write --cache"
		]
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/snikproject/graph.git"
	},
	"author": {
		"name": "Konrad Höffner",
		"url": "https://github.com/konradhoeffner/"
	},
	"contributors": [
		{
			"name": "Thomas Pause",
			"url": "https://github.com/ThomasPause"
		}
	],
	"license": "GPLv3"
}
